import styled from "styled-components";

import theme from "../config/theme";

const ErrorStyle = styled("div")`
  ${theme.typography.bodySmall};
  color: ${theme.colors.red};
  text-align: left;
`;

export default ErrorStyle;
